<template>
    <a class="row author-list" :href="url" target="_blank">
        <div class="col-6 author-list-img-wrap">
            <div class="author-list-img">
                <img :src="image">
            </div>
        </div>
        <div class="col-6 author-list-name">
            <div class="author-list-name-name">
                {{name}}
            </div>
            <div class="author-list-name-article">
                <i class="icon icon-article"></i> {{article}} Artikel
            </div>
        </div>
    </a>
</template>

<script>
export default {
    props: ['name', 'image', 'article', 'url']
}
</script>
<style scoped>
a {
    color: #4F4F4F;
}
a:hover {
    text-decoration: none;
}
.author-list {
    align-items: center;
    margin-bottom: 25px;
    float: left;
    width: 100%;
}
.author-list-img-wrap{
   float: left;
    width: auto;  
}
.author-list-name{
    float: left;
    width: 50%;
}
.author-list-img img {
    width: 100px;
    height: 100px;
    object-fit: cover;
}
.author-list-img {
    width: 100px;
    height: 100px;
    border-radius: 50%;
    overflow: hidden;
   
}
.author-list-name .author-list-name-name {
    font-family: "Poppins", sans-serif;
    font-style: normal;
    font-weight: bold;
    font-size: 14px;
    line-height: 21px;
    color: #4F4F4F;
}
.author-list-name-article {
    display: flex;
    align-items: center;
}
.author-list-name-article i {
    margin-right: 10px;
}
.author-list-img-wrap {
    display: flex;
    justify-content: flex-end;
}
</style>
